import { Option } from "@hilma/forms";
import { SchoolStatus } from "../types";

export const schoolStatusOptions: Option[] = [
    { id: SchoolStatus.Pending, value: 'ממתין לאישור' },
    { id: SchoolStatus.Approved, value: 'מאושר' },
    { id: SchoolStatus.Denied, value: 'לא מאושר' },
];